import request from '@/utils/request'

// 钢瓶信息接口
// const bottleApiList = [
//     {url: "/ycps/gas/pic"},
//     {url: "/ycps/gas/filling-list"},
//     {url: "/ycps/gas/delivery-list"},
//     {url: "/ycps/gas/gas-list"},
//     {url: "/ycps/gas/use-list"},
//     {url: "/ycps/gas/recycling-list"},
//     {url: "/ycps/gas/detection-list"},
//     {url: "/ycps/gas/scrap-list"},
//     {url: "/ycps/gas/other-list"},
// ]
// 钢瓶信息
export function getBottleInfo(params, type = 0) {
    return request({
        // url: bottleApiList[type].url,
        url: (type == 1 ? '/bottle/fill-status/' : '/bottle/status/')+params.bottle_id,
        method: 'get',
    })
}

// 钢瓶充装
export function bottleFillingAdd(data) {
    return request({
        url: '/bottle/filling',
        method: 'post',
        data
    })
}

// 配送提交
export function bottleDeliveryAdd(data) {
    return request({
        url: '/bottle/allocating',
        method: 'post',
        data
    })
}

// 送气提交
export function bottleGasAdd(data) {
    return request({
        url: '/bottle/delivering',
        method: 'post',
        data
    })
}

// 使用提交
export function bottleUseAdd(data) {
    return request({
        url: '/bottle/using',
        method: 'post',
        data
    })
}

// 回收提交
export function bottleRecyclingAdd(data) {
    return request({
        url: '/bottle/recycling',
        method: 'post',
        data
    })
}

// 检测提交
export function bottleDetectionAdd(data){
    return request({
        url: '/bottle/examining',
        method: 'post',
        data
    })
}

// 检测提交
export function bottleScrapAdd(data){
    return request({
        url: '/bottle/destroying',
        method: 'post',
        data
    })
}

// 检测提交
export function bottleOtherAdd(data){
    return request({
        url: '/bottle/other',
        method: 'post',
        data
    })
}


// 车牌识别
export function carLicense(data) {
    return request({
        url: '/ycps/tools/carLicense',
        method: 'post',
        data
    })
}

// 建档钢瓶查找
export function airbottleSearch(data) {
    return request({
        url: '/ycps/airbottle/search',
        method: 'post',
        data
    })
}

// 钢瓶建档
export function airbottleCreate(data) {
    return request({
        url: '/ycps/airbottle/create',
        method: 'post',
        data
    })
}

// 批量充装
export function batchFillings(data) {
    return request({
        url: '/bottle/batch_filling',
        method: 'post',
        data
    })
}

// 配送工列表
export function getStaffList() {
    return request({
        url: '/ycps/commont/shop-marki',
        method: 'get',
    })
}
